import React, { useEffect, useState } from "react";
import { Loader2, RefreshCw, Search, Star } from "lucide-react";
import { api } from "../../lib/api";
import { act } from "../../lib/sales";
import { InviteFilter } from "../sales/InviteBadge";

function SyncBar({ admin, onDone }) {
  const [job, setJob] = useState(null);
  const load = () => api.get("/admin/vi/vendors/job").then((r) => setJob(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (job?.status !== "running") return undefined;
    const t = setInterval(() => api.get("/admin/vi/vendors/job").then((r) => { setJob(r.data); if (r.data.status !== "running") onDone(); else if (r.data.done % 10 === 0) onDone(); }).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [job?.status]); // eslint-disable-line react-hooks/exhaustive-deps
  const start = async () => { const r = await act(() => api.post("/admin/vi/vendors/sync"), "Sync started — merging duplicates and enriching every lead"); if (r) setJob(r); };
  const run = job?.status === "running";
  return (
    <div className="flex items-center gap-2 text-xs text-black/70 bg-black/[0.03] rounded-xl px-3 py-2 mb-2" data-testid="vi-vendors-sync-bar">
      <p className="flex-1" data-testid="vi-vendors-sync-status">{run ? `Enriching ${job.done || 0} of ${job.total || "…"}${job.merged ? ` · ${job.merged} duplicates merged` : ""}` : job?.finished_at ? `Last sync: ${job.enriched || 0} enriched · ${job.partial || 0} partial · ${job.not_found || 0} not found · ${job.merged_total ?? job.merged ?? 0} duplicates merged` : "New leads are added automatically and enriched every hour."}</p>
      {run ? <Loader2 className="w-4 h-4 animate-spin text-[var(--gold)]" /> : admin && <button onClick={start} className="inline-flex items-center gap-1 font-semibold text-[var(--ink)] hover:text-[var(--gold)]" data-testid="vi-vendors-sync-btn"><RefreshCw className="w-3.5 h-3.5" />Sync &amp; enrich all</button>}
      {admin && <GoogleBtn onDone={onDone} />}
    </div>
  );
}

function GoogleBtn({ onDone }) {
  const [j, setJ] = useState(null);
  const load = () => api.get("/admin/vi/vendors/google-job").then((r) => setJ(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => { if (j?.status !== "running") return undefined; const t = setInterval(() => api.get("/admin/vi/vendors/google-job").then((r) => { setJ(r.data); if (r.data.status !== "running") onDone(); }), 4000); return () => clearInterval(t); }, [j?.status]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!j?.connected) return null;
  if (j.status === "running") return <span className="font-semibold" data-testid="vi-google-progress">Google {j.done}/{j.total} · {j.found} rated</span>;
  const go = async () => { const r = await act(() => api.post("/admin/vi/vendors/google-refresh"), "Pulling Google ratings and reviews"); if (r) setJ({ ...r, connected: true }); };
  return <button onClick={go} className="inline-flex items-center gap-1 font-semibold text-[var(--ink)] hover:text-[var(--gold)]" data-testid="vi-google-refresh-btn" title={j.finished_at ? `Last run: ${j.found} of ${j.total} found on Google` : ""}><Star className="w-3.5 h-3.5" />Google ratings</button>;
}

export function useAllVendors() {
  const [d, setD] = useState({ rows: [], total: 0, enriched: 0 });
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [invite, setInvite] = useState("");
  const load = (skip = 0) => { setBusy(true); return api.get("/admin/vi/vendors", { params: { q, invite, skip, limit: 50 } }).then((r) => setD((x) => (skip ? { ...r.data, rows: [...x.rows, ...r.data.rows] } : r.data))).catch(() => {}).finally(() => setBusy(false)); };
  useEffect(() => { const t = setTimeout(() => load(0), 250); return () => clearTimeout(t); }, [q, invite]); // eslint-disable-line react-hooks/exhaustive-deps
  return { ...d, q, setQ, invite, setInvite, busy, load };
}

export function AllVendorsHead({ av, admin }) {
  return (
    <>
      <SyncBar admin={admin} onDone={() => av.load(0)} />
      <div className="flex items-center gap-2 mb-2">
        <div className="flex-1 min-w-0 flex items-center bg-white border border-[var(--line)] rounded-full pl-3">
          <Search className="w-3.5 h-3.5 text-black/60" /><input value={av.q} onChange={(e) => av.setQ(e.target.value)} placeholder="Filter by name, city, phone…" className="flex-1 min-w-0 bg-transparent px-2 py-1.5 text-xs focus:outline-none" data-testid="vi-vendors-filter" />
        </div>
        <InviteFilter value={av.invite} onChange={av.setInvite} id="vi-vendors-invite-filter" />
      </div>
      <p className="text-xs text-black/60 mb-1" data-testid="vi-vendors-count">{av.total} vendors · {av.enriched} enriched by AI</p>
    </>
  );
}
